export const dummyWishes = [
    {
        id: "1",
        name: "Aiman Shahar",
        guestWish: "Selamat Pengantin Baru 🤍",
        createdAt: { toDate: () => new Date() },
    },
    {
        id: "2",
        name: "Amin",
        guestWish: "Tahniahh sahabat di atas perkahwinan. Wishing you a lifetime of love, joy, and happiness ✨",
        createdAt: { toDate: () => new Date() },
    },
    {
        id: "3",
        name: "Izzati",
        guestWish: "Congrats Adam & Hawa on your marriage 😘✨",
        createdAt: { toDate: () => new Date() },
    },
    {
        id: "4",
        name: "Zul",
        guestWish: "Congratulations Adam & Hawa 💕🤍 Moga perkahwinan yang dibina berkekalan hingga akhir hayat",
        createdAt: { toDate: () => new Date() },
    },
    {
        id: "5",
        name: "Syafiq & Amirah",
        guestWish: "Selamat pengantin baru buat adam dan pasangan!",
        createdAt: { toDate: () => new Date() },
    },

];